const About = () => import("@/pages/About");
const Bracelet = () => import("@/pages/Bracelet");
const Features = () => import("@/pages/Features");
const HowItWorks = () => import("@/pages/HowItWorks");
const ContactUs = () => import("@/pages/ContactUs");
const TermsAndConditions = () => import("@/pages/TermsAndConditions");
const PrivacyPolicy = () => import("@/pages/PrivacyPolicy");
const WarrantyPolicy = () => import("@/pages/WarrantyPolicy");
const CookiesPolicy = () => import("@/pages/CookiesPolicy");
const Verification = () => import("@/pages/Verification");
const NotFound = () => import("@/pages/NotFound");
const Order = () => import("@/pages/Order");
const BuyNow = () => import("@/pages/BuyNow");
const Troubleshoot = () => import("@/pages/Troubleshoot");

export default [
  {
    path: "/",
    name: "about",
    component: About,
    meta: {
      title: "Upmood | Emotion Tracker & Mood Sensor - Wearable",
      metaTags: [
        {
          name: "description",
          content:
            "Upmood is a wearable emotion tracker & mood sensor technology that gives you an insight on your emotion through an app so you can manage your emotional health and social networking interaction."
        }
      ]
    }
  },
  {
    path: "/Bracelet",
    name: "bracelet",
    component: Bracelet,
    meta: {
      title: "Bracelet - Emotion Sensing Technology - Mood App | Upmood",
      metaTags: [
        {
          name: "description",
          content:
            "The built-in PPG sensor in the Upmood wearable emotion & mood tracker app detects your heart rate, stress levels, and vitality levels in real-time to give you an insight on your emotional trends and progress."
        }
      ]
    }
  },
  {
    path: "/Features",
    name: "features",
    component: Features,
    meta: {
      title: "Features - Emotional Awareness - Mood Monitoring App | Upmood",
      metaTags: [
        {
          name: "description",
          content:
            "A fully-featured band that is paired with an emotional awareness & monitoring app, Upmood comes with a smartphone notification, daily emotion tracker, a variety of straps, and stickers that represent a spectrum of emotions."
        }
      ]
    }
  },
  {
    path: "/HowItWorks",
    name: "howitworks",
    component: HowItWorks,
    meta: {
      title: "How It Works | Upmood",
      metaTags: [
        {
          name: "description",
          content:
            "A fully-featured band that is paired with an emotional awareness & monitoring app, Upmood comes with a smartphone notification, daily emotion tracker, a variety of straps, and stickers that represent a spectrum of emotions."
        }
      ]
    }
  },
  {
    path: "/ContactUs",
    name: "contactUs",
    component: ContactUs,
    meta: {
      title: "Contact - Wearable Emotion - Mood Tracker Band | Upmood",
      metaTags: [
        {
          name: "description",
          content:
            "Want to know more about Upmood emotion and mood tracker technology? Let us help you be more aware of your emotion by reaching out to us."
        }
      ]
    }
  },
  {
    path: "/TermsAndConditions",
    name: "termsAndConditions",
    component: TermsAndConditions,
    meta: {
      title: "Terms and Conditions | Upmood",
      metaTags: [
        {
          name: "description",
          content: "Upmood - Terms and Conditions"
        }
      ]
    }
  },
  {
    path: "/PrivacyPolicy",
    name: "privacyPolicy",
    component: PrivacyPolicy,
    meta: {
      title: "Privacy Policy | Upmood",
      metaTags: [
        {
          name: "description",
          content: "Upmood - Privacy Policy"
        }
      ]
    }
  },
  {
    path: "/WarrantyPolicy",
    name: "warrantyPolicy",
    component: WarrantyPolicy,
    meta: {
      title: "Warranty Policy | Upmood",
      metaTags: [
        {
          name: "description",
          content: "Upmood - Warranty Policy"
        }
      ]
    }
  },
  {
    path: "/CookiesPolicy",
    name: "cookiesPolicy",
    component: CookiesPolicy,
    meta: {
      title: "Cookies Policy | Upmood",
      metaTags: [
        {
          name: "description",
          content: "Upmood - Cookies Policy"
        }
      ]
    }
  },
  {
    path: "/verifysuccess*",
    name: "verification",
    component: Verification,
    meta: {
      title: "Verification | Upmood",
      metaTags: [
        {
          name: "description",
          content: "Upmood - Verification"
        }
      ]
    }
  },

  {
    path: "/Order",
    name: "order",
    component: Order,
    props: true,
    meta: {
      title: "Order | Upmood",
      metaTags: [
        {
          name: "description",
          content: "Upmood - Order"
        }
      ]
    }
  },

  {
    path: "/BuyNow",
    name: "buynow",
    component: BuyNow,
    meta: {
      title: "BuyNow | Upmood",
      metaTags: [
        {
          name: "description",
          content: "Upmood - BuyNow"
        }
      ]
    }
  },

  {
    path: "/Troubleshoot",
    name: "troubleshoot",
    component: Troubleshoot,
    meta: {
      title: "Troubleshoot | Upmood",
      metaTags: [
        {
          name: "description",
          content: "Upmood - Troubleshoot"
        }
      ]
    }
  },

  {
    path: "/*",
    component: NotFound,
    meta: {
      title: "Not Found | Upmood",
      metaTags: [
        {
          name: "description",
          content: "Upmood - Page Not Found"
        }
      ]
    }
  }
];
